import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { InputAdornment } from '@mui/material'; // Import InputAdornment
import dayjs from "dayjs";

function CustomDatePicker({
    name,
    onChange,
    onBlur,
    value,
    error,
    helperText,
    FormHelperTextProps,
    isDisabled,
    minDate,
    no_border,
    maxDate,
    width = '100%',
    StartIcon // Passing Icon through props
}) {
    const ModifiedDateOtherStyles = {
        '& .MuiInputBase-input.MuiOutlinedInput-input': {
            padding: '8px 0px',
            fontSize: '15px',
            height: '25px',
        },
        // Modify the background color when the input is disabled
        "& .MuiOutlinedInput-root.Mui-disabled": {
            backgroundColor: '#f0f0f0', // Set your desired background color here
            WebkitTextFillColor: "#272727",
        },
        "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#272727", // Ensure text color is appropriate when disabled
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: no_border ? 'none' : '',
        },
    };

    const ModifiedDatePickerOutline = {
        '& .MuiOutlinedInput-root': {
            fontSize: '15px',
            paddingLeft: '5px',
            '& fieldset': {
                borderColor: no_border ? 'white' : '#C0C0C0',
            },
            '&:hover fieldset': {
                borderColor: no_border ? 'white' : '#C0C0C0',
            },
            '&.Mui-focused fieldset': {
                borderColor: no_border ? 'white' : '#C0C0C0',
            },
        },

    };

    return (
        <div className={` ${width ? 'force-full-width-mobile' : ''}`} style={{ width: width || '100%' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                    minDate={minDate}
                    disabled={isDisabled}
                    maxDate={maxDate}
                    onChange={(date) => {
                        onChange(date?.format("DD-MM-YYYY"));
                    }}
                    fullWidth
                    format="DD-MM-YYYY"
                    name={name}
                    autoComplete="off"
                    size="small"
                    onBlur={onBlur}
                    value={value}

                    slotProps={{
                        actionBar: {
                            actions: ['clear'],
                        },
                        textField: {
                            helperText: helperText ? helperText : '',
                            error: error ? error : false,
                            fullWidth: true,
                            InputProps: {
                                startAdornment: StartIcon ? (
                                    <InputAdornment position="start">
                                        {/* {StartIcon ? <StartIcon className='start-icon' /> : null}  */}
                                    </InputAdornment>
                                ) : null
                            }
                        },
                    }}
                    sx={{ ...ModifiedDatePickerOutline, ...ModifiedDateOtherStyles }}
                />
            </LocalizationProvider>
        </div>

    );
}

export default CustomDatePicker;
